module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1046-6db5c18b00bd8c1e872f4c524503e30b.png";